import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Heart, X } from 'lucide-react';
import { useFavorites } from '../context/FavoritesContext';

const MiniFavorites = () => {
  const { favoriteItems, getFavoritesCount, removeFromFavorites } = useFavorites();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { country } = useParams();

  const favoritesCount = getFavoritesCount();

  const handleViewAll = () => {
    setIsOpen(false);
    navigate(`/${country}/favorites`);
  };

  const handleProductClick = (productId) => {
    setIsOpen(false);
    navigate(`/${country}/products/${productId}`);
  };

  return (
    <div className="relative">
      {/* Favorites Icon */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative p-2 hover:bg-aug-cream rounded-lg transition-colors"
        data-testid="mini-favorites-button"
      >
        <Heart 
          className={`w-6 h-6 ${favoritesCount > 0 ? 'fill-red-500 text-red-500' : 'text-aug-gray-dark'}`}
        />
        {favoritesCount > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
            {favoritesCount}
          </span>
        )}
      </button>

      {/* Dropdown */}
      {isOpen && (
        <>
          {/* Overlay */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />

          {/* Favorites Dropdown */}
          <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-xl shadow-2xl z-50 max-h-96 overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-aug-gray-light">
              <h3 className="font-semibold text-aug-gray-dark">
                Meus Favoritos ({favoritesCount})
              </h3>
              <button
                onClick={() => setIsOpen(false)}
                className="p-1 hover:bg-aug-cream rounded"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Items */}
            {favoriteItems.length === 0 ? (
              <div className="p-8 text-center text-aug-gray-medium">
                <Heart className="w-12 h-12 mx-auto mb-2 opacity-30" />
                <p>Nenhum favorito ainda</p>
              </div>
            ) : (
              <>
                <div className="max-h-60 overflow-y-auto p-4 space-y-3">
                  {favoriteItems.slice(0, 5).map((item) => (
                    <div key={item.id} className="flex gap-3 group">
                      <div
                        onClick={() => handleProductClick(item.id)}
                        className="flex-1 flex gap-3 cursor-pointer"
                      >
                        <img
                          src={item.images?.[0] || 'https://via.placeholder.com/80'}
                          alt={item.name}
                          className="w-16 h-16 object-cover rounded"
                        />
                        <div className="flex-1 min-w-0">
                          <h4 className="text-sm font-medium text-aug-gray-dark truncate group-hover:text-aug-blue transition-colors">
                            {item.name}
                          </h4>
                          <p className="text-xs text-aug-gray-medium">
                            {item.category_name}
                          </p>
                          <p className="text-sm font-semibold" style={{ color: '#1B5E20' }}>
                            R$ {(item.sale_price || item.regular_price).toFixed(2)}
                          </p>
                        </div>
                      </div>
                      <button
                        onClick={() => removeFromFavorites(item.id)}
                        className="text-red-500 hover:bg-red-50 p-1 rounded"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>

                {/* Footer */}
                <div className="p-4 border-t border-aug-gray-light">
                  <button
                    onClick={handleViewAll}
                    className="w-full bg-aug-blue hover:bg-aug-blue-dark text-white py-3 rounded-lg font-semibold transition-colors"
                    style={{ backgroundColor: '#1B5E20' }}
                  >
                    Ver Todos ({favoritesCount})
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MiniFavorites;
